import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { useInView } from "react-intersection-observer";

var RevealOnScrollSafe = function RevealOnScrollSafe(_ref) {
  var children = _ref.children,
      triggerOnce = _ref.triggerOnce,
      threshold = _ref.threshold;

  var _useState = useState(true),
      visible = _useState[0],
      setVisible = _useState[1];

  var _useInView = useInView({
    threshold: threshold,
    triggerOnce: triggerOnce
  }),
      ref = _useInView[0],
      inView = _useInView[1];

  useEffect(function () {
    setVisible(inView);
  }, [inView]);

  return React.createElement(
    Wrapper,
    { className: visible && "visible", ref: ref },
    children
  );
};

export var RevealOnScroll = function RevealOnScroll(props) {
  if (typeof window !== "undefined" && "IntersectionObserver" in window) {
    return React.createElement(RevealOnScrollSafe, props);
  } else {
    return React.createElement(
      Wrapper,
      { className: "visible" },
      props.children
    );
  }
};

var Wrapper = styled.div.withConfig({
  displayName: "RevealOnScroll__Wrapper",
  componentId: "sc-1j0qy9i-0"
})(["opacity:0;transform:translateY(20px);&.visible{opacity:1;transform:translateY(0);}transition:all 800ms cubic-bezier(0.03,0.63,0.46,0.96);"]);

RevealOnScroll.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node,
  triggerOnce: PropTypes.bool,
  threshold: PropTypes.number
} : {};

RevealOnScroll.defaultProps = {
  triggerOnce: true,
  threshold: 0.5
};